import React from 'react';
import PropTypes from 'prop-types';
import { vsprintf } from 'sprintf-js';
import {
  Icon,
  Table,
} from 'semantic-ui-react';

import SnukTableCell from './SnukTableCell';
import DeleteModal from '../DeleteModal';
import EditModal from '../EditModal';

const SnukTableRow = (props) => {
  const {
    shape, values, editable, openEditModalAction, openDeleteModalAction,
    deleteModalProps, editModalProps,
  } = props;
  return (
    <Table.Row>
      {editable && (
        <Table.Cell collapsing singleLine>
          <Icon
            name="edit"
            style={{ color: '#1d7aca' }}
            onClick={() => openEditModalAction(values.id)}
            className="hover"
          />
          <Icon
            name="delete"
            style={{ color: 'red' }}
            onClick={() => openDeleteModalAction(values.id)}
            className="hover"
          />
        </Table.Cell>
      )}
      {Array.from(shape).map(([key, info]) => {
        if (info.header.colSpan && info.header.colSpan !== '1' && info.cell.renderFn) {
          const { renderFn, ...rest } = info.cell;

          return (
            renderFn(values[key]).map((cellComponent, i) => (
              <SnukTableCell
                key={`${key}${i}`}
                id={key}
                values={values}
                renderFn={() => cellComponent}
                {...rest}
              />
            ))
          );
        }
        return (
          <SnukTableCell
            key={key}
            id={key}
            values={values}
            {...info.cell}
          />
        );
      })}
      {editModalProps && values.isEditModalOpen && (() => {
        const {
          titleFormat, titleValues, containerElem: ComponentToRender, isPending, ...rest
        } = editModalProps;
        const printfArgs = titleValues.map(fieldName => values[fieldName]);
        const title = vsprintf(titleFormat, printfArgs);
        if (ComponentToRender) {
          return (
            <ComponentToRender values={values} {...editModalProps} />
          );
        }

        return (
          <EditModal
            {...rest}
            itemId={values.id}
            initValues={values}
            isPending={isPending}
            title={title}
          />
        );
      })()}
      {deleteModalProps && values.isDeleteModalOpen && (() => {
        const {
          textFormat, textValues, isPending, ...rest
        } = deleteModalProps;
        const printfArgs = textValues.map(fieldName => values[fieldName]);
        const text = vsprintf(textFormat, printfArgs);
        return (
          <DeleteModal
            {...rest}
            itemId={values.id}
            isPending={isPending}
            text={text}
          />
        );
      })()}
    </Table.Row>
  );
};

SnukTableRow.propTypes = {
  shape: PropTypes.shape({}).isRequired,
  values: PropTypes.shape({}).isRequired,
  editable: PropTypes.bool,
  openEditModalAction: PropTypes.func,
  openDeleteModalAction: PropTypes.func,
  deleteModalProps: PropTypes.shape({
    ...DeleteModal.propTypes,
    isPending: PropTypes.bool,
    itemId: PropTypes.string,
    // note: we receive textFormat and textValues to render the text
    text: PropTypes.string,
    textFormat: PropTypes.string.isRequired,
    textValues: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ])).isRequired,
  }),
  editModalProps: PropTypes.shape({
    ...EditModal.propTypes,
    isPending: PropTypes.bool,
    itemId: PropTypes.string,
    // note: we receive titleFormat and titleValues to render the title
    title: PropTypes.string,
    titleFormat: PropTypes.string.isRequired,
    titleValues: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ])).isRequired,
  }),
};

SnukTableRow.defaultProps = {
  editable: false,
  openEditModalAction: null,
  openDeleteModalAction: null,
  deleteModalProps: null,
  editModalProps: null,
};

export default SnukTableRow;



// WEBPACK FOOTER //
// ./src/components/reusable/SnukTable/SnukTableRow.js